import { render, staticRenderFns } from "./referenzen-kunden-1.vue?vue&type=template&id=46f1cc82&"
import script from "./referenzen-kunden-1.vue?vue&type=script&lang=js&"
export * from "./referenzen-kunden-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports